import VueRouter from 'vue-router'
import AllMenus from '@/components/AllMenus'
import DisplayMenu from '@/components/DisplayMenu'


export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'AllMenus',
            component: AllMenus
        },
        {
            path: '/:id',
            name: 'DisplayMenu',
            component: DisplayMenu
        },
        { 
            path: "*", 
            component: AllMenus 
        }
    ]
})